import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { withRouter} from 'react-router-dom'
import { connect } from 'react-redux'
import { signup,login,googleLogin } from '../../actions/session'
import SignupForm from '../../components/forms/SignupForm'
import GoogleLogin from 'react-google-login'
import CartoonDevice from '../../components/misc/CartoonDevice'
import Icon from '../../components/misc/Icons'
import DocumentTitle from 'react-document-title' 
 

const responseGoogle = (response) => {}


class SignUpWithGoogleBtn extends React.PureComponent{


	render(){  
    
		return(

			<GoogleLogin
				clientId={process.env.REACT_APP_PLICKERS_GOOGLE_AUTH_CLIENT_ID}
				onSuccess={this.props.googleLogin}
				onFailure={responseGoogle}
				className='signup-continueWithGoogleBtn signup-continueWithGoogleBtn--default'
				type='submit'
			>  

				<div className='signup-continueWithGoogleBtn-centerContent'>
					<div className='signup-continueWithGoogleBtn-centerContent-icon'>
						<Icon name='googleLogoSignInColor' />
						<Icon name='googleLogoSignInGray' />
					</div>
					<div className='signup-continueWithGoogleBtn-centerContent-label'>
						Continue with Google
					</div>
				</div>

			</GoogleLogin>
		)
	}
}





class SignupContainer extends Component {

	constructor(){
		super()
		this.handleSignup=this.handleSignup.bind(this)
		this.goToLogin=this.goToLogin.bind(this)
		this.onPreSubmit=this.onPreSubmit.bind(this)
		this.googleLogin=this.googleLogin.bind(this)
	
		this.state={
			signupError: null, 
			submitLoading:false
		}

	}


	componentDidMount(){
		var elements = document.getElementsByClassName('signup-continueWithGoogleBtn signup-continueWithGoogleBtn--default')
		const googleButton=ReactDOM.findDOMNode(elements[0]) //Clean this up
		if(googleButton){
			googleButton.tabIndex='1'
			setTimeout(function () {
				googleButton.focus()

			}, 500)
		}
	}

	

	onPreSubmit(){
		this.setState({submitLoading:true})
	}


	handleSignup(data){
		this.setState({signupError:null})
		this.props.signup(this.appendData(data)).then((response) => {
			//Once signed up log user in
			const loginData={
				email:data.email,
				password:data.password
			}
			this.props.login(loginData)
		})
			.catch(error => {
				this.setState({submitLoading:false})
				let errorMessage='Please try again. If the problem persists, contact support.'
				if(error.response && error.response.status===409){
					errorMessage=`An account for ${data.email} already exists.`
				}
				this.setState({signupError:errorMessage})
			})

	}



	googleLogin(googleUser){
		this.setState({submitLoading:true})
		const requestData={
			idToken:googleUser.tokenId
		}
		this.props.googleLogin(requestData).then((response) => {
			const authInstance=window.gapi.auth2.getAuthInstance()
			authInstance.disconnect()
		})
	}


 

	goToLogin(){
		 this.props.history.push('login')
	}

	appendData(data){
		const nowDate = new Date()
		return {...data, 
			'clientModified':nowDate,
			'userCreated':nowDate,
			'title':''
		}
	}

	render() {
		return (
			<DocumentTitle title='Create Account - Plickers'>
				<div className='signup marketing notranslate'>						
					<div className='signup-centerBlock'>
						<div className='signup-centerBlock--top'>						
							<div className='signup-centerBlock-logoSpacer-top' />
							<div className='signup-centerBlock-logo'>
								<Icon name='logo' />
							</div>
							<div className='signup-centerBlock-logoSpacer-bottom' />
						</div>
						<div className='signup-centerBlock--middle'>
							<div className='signup-centerBlock-title'>
								Sign up for free
							</div>
							<div className='signup-centerBlock-spacer' />
						
							<div className='signup-centerBlock-divider'>
								<div className='signup-centerBlock-divider-line' />
								<div className='signup-centerBlock-divider-label'>
									or use email and password
								</div>
								<div className='signup-centerBlock-divider-line' />

							</div>						
							
							<SignupForm 
								onPreSubmit={this.onPreSubmit}
								onSubmit={this.handleSignup} 
								signupError={this.state.signupError} 
								submitLoading={this.state.submitLoading}
							/>
							<SignUpWithGoogleBtn googleLogin={this.googleLogin} />
						</div>

						<div className='signup-centerBlock--bottom'>						
							<div className='signup-centerBlock-goToLoginBtn' onClick={this.goToLogin}> 
								If you already have an account, click here to sign in
							</div>						
						</div>
						
						
					</div>				 
				  

					<div className='signup-deviceArray'>
				 		<div className='signup-deviceArray-topLeft'>
				 			<CartoonDevice device='laptop' screen='laptopSetEditor' />
				 		</div>
				 		<div className='signup-deviceArray-topRight'>
				 			<CartoonDevice device='iPhone' screen='iPhoneNowPlayingReview' />
				 		</div>
				 		<div className='signup-deviceArray-bottomRight'>
				 			<CartoonDevice device='laptop' screen='laptopSetEditor' />
				 		</div>
						<div className='signup-deviceArray-bottomLeft'>
							<CartoonDevice device='iPhone' screen='iPhoneNowPlayingReview' />
						</div>					
					</div>

				</div>
			</DocumentTitle>
		)
	}
}



export default withRouter(connect(
	(state) => ({

	}),
	{ signup,login,googleLogin }
)(SignupContainer))


